<p-card *ngIf="paymentConfirmationDetails">
    <ng-template pTemplate="header">
        <div class="payment-confirm-img p-4">
            <div class="p-4 w-full h-full flex justify-content-center align-items-center">
                <img alt="Card" class="w-full" src="assets/svg/check_mark_confirmation.svg" />
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="title"> Payment confirmed! </ng-template>

    <p>Thank you for your payment. We're processing it now, which can take up to 3 business days.</p>

    <p><strong>Payment Details</strong></p>

    <div>
        <div class="flex flex-row p-1">
            <label class="text-slate-500 w-6">Amount Paid: </label>
            <strong data-auto-id="payment-confirmation-amount-paid" class="w-6">
                {{paymentConfirmationDetails.amount | currency:'USD':'symbol-narrow' }}
            </strong>
        </div>

        <div class="flex flex-row p-1">
            <label class="text-slate-500 w-6">Payment Date: </label>
            <strong data-auto-id="payment-confirmation-paid-date" class="w-6">
                {{paymentConfirmationDetails.date}}
            </strong>
        </div>

        <div class="flex flex-row p-1">
            <label class="text-slate-500 w-6">Confirmation Number: </label>
            <strong data-auto-id="payment-confirmation-auth-code" class="w-6">
                {{paymentConfirmationDetails.authCode}}
            </strong>
        </div>
    </div>
</p-card>
